import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { googleLogout } from "@react-oauth/google";
import "./Navbar.css";

const Navbar = () => {
  const [adminOpen, setAdminOpen] = useState(false);
  const [rootCausesOpen, setRootCausesOpen] = useState(false);
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const adminRef = useRef(null);
  const rootCausesRef = useRef(null);
  const userMenuRef = useRef(null);
  const navigate = useNavigate();

  const user = (() => {
    try {
      return JSON.parse(localStorage.getItem("user") || "null");
    } catch {
      return null;
    }
  })();

  const handleLogout = () => {
    googleLogout();
    localStorage.removeItem("authToken");
    localStorage.removeItem("user");
    navigate("/login");
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (adminRef.current && !adminRef.current.contains(e.target)) {
        setAdminOpen(false);
      }
      if (rootCausesRef.current && !rootCausesRef.current.contains(e.target)) {
        setRootCausesOpen(false);
      }
      if (userMenuRef.current && !userMenuRef.current.contains(e.target)) {
        setUserMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-logo">
          <Link to="/">
            <img
              src="https://my.exotel.com/assets/i/exotel-updated-logo-white.svg"
              alt="logo"
              className="navbar-logo-img"
            />
          </Link>
        </div>
        <div className="navbar-links">
          <Link to="/" className="navbar-link">
            Tickets
          </Link>
          <Link to="/gchat/conversations" className="navbar-link">
            Chats
          </Link>
          <Link to="/rag" className="navbar-link">
            RAG Analysis
          </Link>
          <div className="navbar-dropdown" ref={rootCausesRef}>
            <button
              className="navbar-link navbar-dropdown-toggle"
              onClick={() => setRootCausesOpen((prev) => !prev)}
            >
              Root Causes <span className="navbar-dropdown-arrow">{rootCausesOpen ? "▲" : "▼"}</span>
            </button>
            {rootCausesOpen && (
              <div className="navbar-dropdown-menu">
                <Link
                  to="/buckets"
                  className="navbar-dropdown-item"
                  onClick={() => setRootCausesOpen(false)}
                >
                  Ticket Root Causes
                </Link>
                <Link
                  to="/gchat/buckets"
                  className="navbar-dropdown-item"
                  onClick={() => setRootCausesOpen(false)}
                >
                  Chat Root Causes
                </Link>
              </div>
            )}
          </div>
          <Link to="/gchat/preventive-actions" className="navbar-link">
            Preventive Actions
          </Link>
          <Link to="/metrics" className="navbar-link">
            Metrics
          </Link>
          <div className="navbar-dropdown" ref={adminRef}>
            <button
              className="navbar-link navbar-dropdown-toggle"
              onClick={() => setAdminOpen((prev) => !prev)}
            >
              Admin <span className="navbar-dropdown-arrow">{adminOpen ? "▲" : "▼"}</span>
            </button>
            {adminOpen && (
              <div className="navbar-dropdown-menu">
                <div className="navbar-dropdown-group-label">Jobs</div>
                <Link
                  to="/scheduler"
                  className="navbar-dropdown-item"
                  onClick={() => setAdminOpen(false)}
                >
                  Ticket Analysis
                </Link>
                <Link
                  to="/gchat"
                  className="navbar-dropdown-item"
                  onClick={() => setAdminOpen(false)}
                >
                  Chat Analysis
                </Link>
                <Link
                  to="/rca-scheduler"
                  className="navbar-dropdown-item"
                  onClick={() => setAdminOpen(false)}
                >
                  RCA Analysis
                </Link>
                <Link
                  to="/daily-dipstick"
                  className="navbar-dropdown-item"
                  onClick={() => setAdminOpen(false)}
                >
                  Daily Dip Stick
                </Link>
                <div className="navbar-dropdown-divider" />
                <Link
                  to="/api-keys"
                  className="navbar-dropdown-item"
                  onClick={() => setAdminOpen(false)}
                >
                  API Keys
                </Link>
                <Link
                  to="/prompts"
                  className="navbar-dropdown-item"
                  onClick={() => setAdminOpen(false)}
                >
                  Prompts
                </Link>
              </div>
            )}
          </div>

          {user && (
            <div className="navbar-dropdown navbar-user-menu" ref={userMenuRef}>
              <button
                className="navbar-user-toggle"
                onClick={() => setUserMenuOpen((prev) => !prev)}
              >
                {user.picture ? (
                  <img
                    src={user.picture}
                    alt=""
                    className="navbar-user-avatar"
                    referrerPolicy="no-referrer"
                  />
                ) : (
                  <span className="navbar-user-initials">
                    {(user.name || user.email || "?").charAt(0).toUpperCase()}
                  </span>
                )}
              </button>
              {userMenuOpen && (
                <div className="navbar-dropdown-menu navbar-user-dropdown">
                  <div className="navbar-user-info">
                    <span className="navbar-user-name">{user.name}</span>
                    <span className="navbar-user-email">{user.email}</span>
                  </div>
                  <button
                    className="navbar-dropdown-item navbar-logout-btn"
                    onClick={handleLogout}
                  >
                    Sign out
                  </button>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
